import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

export const PICKER_DROPDOWN_WIDTH = 300;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledOption = styled.div({
	display: 'flex',
	flexDirection: 'column',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledLabel = styled.div<{ withPadding?: boolean }>(
	{
		display: 'flex',
		alignItems: 'center',
		height: '24px',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	(props) =>
		props.withPadding
			? {
					paddingBlock: `0 ${token('space.025')}`,
				}
			: {},
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledLabelIcon = styled.div({
	display: 'flex',
	marginLeft: token('space.025'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledIcon = styled.img({
	borderRadius: token('radius.full'),
	height: '16px',
	width: '16px',
	display: 'flex',
	marginTop: token('space.025'),
	marginRight: token('space.025'),
	marginBottom: token('space.025'),
	marginLeft: token('space.025'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledLabelText = styled.div({
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	marginLeft: token('space.050'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledLozenge = styled.div({
	display: 'flex',
	marginLeft: token('space.050'),
	maxWidth: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledLozengeLabel = styled.span({
	display: 'inline-block',
	width: '100%',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	verticalAlign: 'top',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledSecondaryLabel = styled.div({
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	font: token('font.body.small'),

	color: token('color.text.subtlest'),
	marginTop: token('space.negative.025'), // negative of same value used for "gap"
	marginLeft: token('space.050'),
	alignItems: 'center',
	display: 'flex',
	gap: token('space.025'), // offset by same value in marginTop
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StylesGroupIconContainer = styled.div({
	marginTop: token('space.025'),
	marginRight: token('space.025'),
	marginBottom: token('space.025'),
	marginLeft: token('space.025'),
});
